import { render, staticRenderFns } from "./telegram-notify.vue?vue&type=template&id=2b0a0494&scoped=true&"
import script from "./telegram-notify.vue?vue&type=script&lang=js&"
export * from "./telegram-notify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a0494",
  null
  
)

export default component.exports